<template>
  <Modal v-model="isShow" width="500" :footer-hide="true" :closable="closable" :mask-closable="closable" @on-cancel="cancel" class-name="changePWD-modal">
    <span class="title">{{ title }}</span>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" label-position="right" :label-width="0">
      <!-- <FormItem label="旧密码" prop="oldpwd"> -->
      <FormItem prop="oldpwd">
        <Input v-model="formValidate.oldpwd" type="password" placeholder="旧密码" />
      </FormItem>
      <!-- <FormItem label="新密码" prop="newpwd"> -->
      <FormItem prop="newpwd">
        <Input v-model="formValidate.newpwd" type="password" placeholder="新密码" />
      </FormItem>
      <!-- <FormItem label="重复密码" prop="passwdCheck"> -->
      <FormItem prop="passwdCheck">
        <Input v-model="formValidate.passwdCheck" type="password" placeholder="重复密码" />
      </FormItem>
      <FormItem>
        <!-- <div style="display:flex;justify-content:space-between;width:100%"> -->
        <Button type="primary" @click="save" style="flex: 1; margin: 10px 0" long>确定</Button>
        <!-- <Button type="primary" @click="reset" style="flex:1;margin-left:5px">重置</Button> -->
        <!-- </div> -->
      </FormItem>
    </Form>
  </Modal>
</template>
<script>
export default {
  props: {
    closable: {
      tyoe: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // const PWDRegExp = /^.*(?=.{6,})(?=.*\d)(?=.*[a-z]|[A-Z]{1,}).*$/;
    // const validatePass = (rele, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请重复新密码"));
    //   } else {
    //     if (!PWDRegExp.test(value))
    //       callback(new Error("密码必须包含数字加英文字母并且长度大于6位"));
    //     if (this.formValidate.passwdCheck !== "") {
    //       // 对第二个密码框单独验证
    //       this.$refs.formValidate.validateField("passwdCheck");
    //     }
    //     callback();
    //   }
    // };
    // const validatePassCheck = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请再次输入密码"));
    //   } else if (value !== this.formValidate.newpwd) {
    //     callback(new Error("两次密码不一样"));
    //   } else {
    //     callback();
    //   }
    // };
    let { verification_rules, error_prompt, verification_func } = this.$app.Cfg.core.account_security
    const PWDRegExp = new RegExp(verification_rules)
    const validatePass = async (rele, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else {
        let hook = null
        try {
          hook = await fxImport("./web/config/core/hook.config.js")
        } catch (error) {}

        if (hook && hook.verificationUserPwd) {
          try {
            await hook.verificationUserPwd(value)
          } catch (error) {
            callback(error)
          }
        } else if (!PWDRegExp.test(value)) {
          callback(new Error(error_prompt))
        }

        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck")
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.formValidate.newpwd) {
        callback(new Error("两次密码不一样"))
      } else {
        callback()
      }
    }
    return {
      loginLoading: false,
      title: "",
      formValidate: {
        oldpwd: "",
        newpwd: "",
        passwdCheck: "",
      },
      ruleValidate: {
        oldpwd: [{ required: true, message: "旧密码不能为空", trigger: "blur" }],
        newpwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ required: true, validator: validatePassCheck, trigger: "blur" }],
      },
    }
  },
  computed: {
    isShow: {
      get() {
        let { isAdmin, isExpirepwd, status } = this.$store.state.core.user

        // if (isExpirepwd) {
        //   this.title = "密码过期请重设"
        // } else if (status == "2") {
        //   this.title = "账号存在安全问题，请先重置密码2"
        // }

        // isAdmin = false;
        return this.show
      },
      set(val) {},
    },
  },
  methods: {
    save() {
      let _this = this
      let enctyptLoginPWD = window.fx_packaging_loginpwd
      this.$refs.formValidate.validate((valid) => {
        console.log(_this.$app.ProjSetting)

        if (valid) {
          let { oldpwd, newpwd } = _this.formValidate
          let _form = {}
          if (_this.$app.ProjSetting.isCryptoLoginPWD) {
            oldpwd = enctyptLoginPWD(oldpwd)
            newpwd = enctyptLoginPWD(newpwd)
          }
          _form["oldpwd"] = oldpwd
          _form["newpwd"] = newpwd
          _this.$curl.post("/api/core/personal/modifypwd", _form).then(() => {
            _this.$Message.info("修改成功")
            this.$refs.formValidate.resetFields()
            // location.href = "login.html";
            this.$store.dispatch("core/logout")
          })
        }
      })
    },
    reset() {
      // this.$refs.formValidate.resetFields();
    },
    cancel() {
      this.$emit("on-cancel")
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 12px;
  display: block;
  font-size: 18px;
  text-align: center;
  margin-bottom: 35px;
  font-weight: bold;
}
.ivu-form-item {
  // margin-bottom: 12px;
  &:last-of-type {
    // margin-bottom: 6px;
  }
}
</style>
<style lang="scss">
.changePWD-modal {
  .ivu-modal {
    top: 28%;
  }
  .ivu-modal-body {
    padding: 35px 65px;
  }
}
</style>
